import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { loadOrderDataAction, fillReturnOrderAction } from "../../store/actions/order.actions";
import { clientConfig } from "../../shared/constant/app.constant";
import { NavButton } from "../../shared/components/navigation/next-button.component";
import { ReturnOrderService } from "../../shared/services/return-order/return-order.service";
import { AppFlowService } from "../../shared/services/app-flow/app-flow.service";
import { CopyHelpers } from "../../shared/helpers/copy.helpers";
import { SpinnerService } from "../../shared/services/spinner.service";
import { ExternalIntegrationsService } from "../../shared/services/externalIntegration.service";
import { getOrderDataFromShopifyOrder } from "../../shared/mapper/shopify-order.mapper";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginPageComponent {
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
    policyUrl: clientConfig.POLICYURL,
  };

  nextButton: NavButton = {
    buttonText: "Continue",
    routeUrl: "/m/main",
    cssClass: "next-btn",
  };
  orderNo: string;
  email: string;
  error: any = null;
  tenantName = clientConfig.TENANTNAME;
  useExternalIntegration: boolean = clientConfig.USE_EXTERNAL_INTEGRATION;
  merchantId: string = clientConfig.MERCHANT_ID;

  constructor(
    private router: Router,
    private orderService: ReturnOrderService,
    private appFlowSerivce: AppFlowService,
    private store: Store<AppState>,
    private spinnerService: SpinnerService,
    private externalIntegrationsService: ExternalIntegrationsService
  ) { }

  resetError() {
    this.error = null;
    return false;
  }

  private async searchOrder(orderNo: string, email: string, merchantId: string) {
    try {
      const res = await this.externalIntegrationsService.searchShopifyOrder(orderNo, email, merchantId).toPromise();
      this.externalIntegrationsService.shopifyOrderDetails = res;


      if (!res?.data?.orders?.edges?.length) {
        this.error = {
          title: "",
          message: "missingLoginOrder",
          translationParams: { merchantName: clientConfig.TITLE },
        };
        return;
      }

      const shopifyOrder = res.data.orders.edges[0].node;

      const orderDataFromShopifyOrder = getOrderDataFromShopifyOrder(shopifyOrder, merchantId);

      this.store.dispatch(loadOrderDataAction({ payload: { ...orderDataFromShopifyOrder, isValid: true } }));

      const ord = CopyHelpers.deepCopy(orderDataFromShopifyOrder);

      if (ord.orders?.length) {
        this.store.dispatch(
          fillReturnOrderAction({
            payload: { order: orderDataFromShopifyOrder.orders[0] }
          })
        );
      }

      if (!this.externalIntegrationsService.shopifyOrderDetails) {
        this.error = {
          title: "",
          message: "missingLoginOrder",
          translationParams: { merchantName: clientConfig.TITLE },
        };
        return;
      }
    } catch (err) {
      this.error = {
        title: "",
        message: "missingLoginOrder",
        translationParams: { merchantName: clientConfig.TITLE },
      };
      return;
    }
  }

  async searchShipment(email: string, orderNo: string) {
    if (!email || !orderNo) {
      return;
    }

    if (this.useExternalIntegration) {
      await this.searchOrder(orderNo, email, this.merchantId);
      this.spinnerService.hide();

      const seq = this.appFlowSerivce.findRouteFromSequence("login");
      this.router.navigate(["m", seq.next]);

      return;
    }

    this.spinnerService.show();
    this.orderService.searchShipment(email, orderNo).subscribe(
      (res: any) => {
        this.spinnerService.hide();
        if (res.success) {
          const order = res.order;
          if (!this.validateOrder(order)) {
            return;
          }

          const ord = CopyHelpers.deepCopy(order);

          if (ord.orders?.length) {

            let consolidatedOrders = ord.orders;

            if (this.tenantName.toLowerCase().trim() === 'dhl') {
              consolidatedOrders = this.consolidateOrderLines(ord.orders, res?.parcelCount);
              ord.orders = consolidatedOrders;
            }

            this.store.dispatch(
              loadOrderDataAction({ payload: { ...ord, isValid: true } })
            );

            this.store.dispatch(
              fillReturnOrderAction({
                payload: { order: consolidatedOrders[0] },
              })
            );
          }
          else {
            this.store.dispatch(
              loadOrderDataAction({ payload: { ...ord, isValid: true } })
            );
          }

          const seq = this.appFlowSerivce.findRouteFromSequence("login");
          this.router.navigate(["m", seq.next]);
        } else {
          this.error = {
            title: "",
            message: "missingLoginOrder",
            translationParams: { merchantName: clientConfig.TITLE },
          };
        }
      },
      () => {
        this.spinnerService.hide();
        this.error = {
          title: "",
          message: "missingLoginOrder",
          translationParams: { merchantName: clientConfig.TITLE },
        };
      }
    );
  }

  consolidateOrderLines(orders: any, parcelCount: number): any {
    this.orderService.parcelCount = parcelCount;

    const orderLines = orders[0]?.orderLines;

    if (!orderLines) return orders;

    const itemMap = new Map();

    for (const line of orderLines) {
      if (itemMap.has(line.itemNumber))
        itemMap.get(line.itemNumber).returnableQuantity += line.returnableQuantity || 0;
      else
        itemMap.set(line.itemNumber, { ...line });
    }

    const newOrders = [...orders];
    newOrders[0] = {
      ...orders[0],
      orderLines: Array.from(itemMap.values())
    };

    return newOrders;
  }

  private validateOrder(order) {
    if (!order.orders || order.orders.length === 0) {
      this.error = {
        title: "",
        message: "missingRequiredOrderInfo",
        translationParams: { merchantName: clientConfig.MERCHANTNAME },
      };
      return false;
    }

    const o = order.orders[0];
    if (
      !o.orderLines ||
      o.orderLines.length === 0 ||
      o.orderLines.filter((x) => !x.itemName || x.returnableQuantity < 1).length > 0
    ) {
      this.error = {
        title: "",
        message: "missingRequiredOrderInfo",
        translationParams: { merchantName: clientConfig.MERCHANTNAME },
      };
      return false;
    }

    return true;
  }
}
